// src/Admin/TeamDashboard.js
import React, { useState } from 'react';
import { AnimatePresence, MotionConfig, motion } from 'framer-motion';
import ResearchAdmin from '../Research/ResearchAdmin';
import StructureBoard from './StructureBoard';
import TeamSettings from './TeamSettings';
import CommissionCalculator from './CommissionCalculator';
import SetupPackages from './SetupPackages';
import EmailTemplateSettings from './EmailTemplateSettings';
import ReportingMailSettings from './ReportingMailSettings';
import FinanceDashboard from './FinanceDashboard';
import AcademyWorkspace from './AcademyWorkspace';
import Protocool from './Protocool';
import { pageVariants } from './dashboardMotion';
import './Teamdashboard.css';

const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const TABS = [
  { id: 'structure', label: 'Sales Pipeline' },
  { id: 'protocool', label: 'Protocool' },
  { id: 'reportings', label: 'Research' },
  { id: 'academy', label: 'Academy' },
  { id: 'finance', label: 'Zahlungen & Provisionen' },
  { id: 'settings', label: 'Settings', icon: <SettingsIcon /> },
];

const TeamIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const MailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);

const CalcIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="4" y="2" width="16" height="20" rx="2" /><path d="M8 6h8" /><path d="M8 11h.01" /><path d="M12 11h.01" /><path d="M16 11h.01" /><path d="M8 15h.01" /><path d="M12 15h.01" /><path d="M16 15v4" /><path d="M8 19h4" />
  </svg>
);

const BellIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

const PackageIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="m7.5 4.27 9 5.15" /><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" /><path d="m3.3 7 8.7 5 8.7-5" /><path d="M12 22V12" />
  </svg>
);

const SETTINGS_TABS = [
  { id: 'team', label: 'Team & Provisionen', icon: <TeamIcon /> },
  { id: 'calculator', label: 'Provisionsrechner', icon: <CalcIcon /> },
  { id: 'setups', label: 'Setup-Pakete', icon: <PackageIcon /> },
  { id: 'templates', label: 'E-Mail-Vorlagen', icon: <MailIcon /> },
  { id: 'reportingmails', label: 'Reporting-Mails', icon: <BellIcon /> },
];

const TeamDashboard = () => {
  const [activeComponent, setActiveComponent] = useState('structure');
  const [settingsView, setSettingsView] = useState('team');
  // Reporting lebt jetzt als Toggle in „Zahlungen & Provisionen". Über die Pipeline
  // kann man direkt in die Reporting-Übersicht springen (öffnet Finance im Reporting-Toggle).
  const [financeView, setFinanceView] = useState('in');
  const openReporting = () => { setFinanceView('reporting'); setActiveComponent('finance'); };

  return (
    <MotionConfig reducedMotion="user">
      <div className="td-wrap">
        <nav className="td-nav">
          <div className="td-brand">
            <img src="/img/sg_bonusclub_combo_white.png" alt="SalesGod · BonusClub" className="td-brand-logo" />
          </div>
          <div className="td-tabs">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                className={`td-tab ${tab.icon ? 'td-tab-icon' : ''} ${activeComponent === tab.id ? 'td-tab-active' : ''}`}
                onClick={() => setActiveComponent(tab.id)}
                aria-label={tab.label}
                title={tab.label}
              >
                {activeComponent === tab.id && (
                  <motion.span layoutId="td-tab-pill" className="td-tab-pill" transition={{ type: 'spring', stiffness: 380, damping: 32 }} />
                )}
                <span className="td-tab-label">{tab.icon || tab.label}</span>
              </button>
            ))}
          </div>
        </nav>

        <div className="td-body">
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={activeComponent}
              className="td-page"
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              {activeComponent === 'reportings' && <ResearchAdmin embedded />}
              {activeComponent === 'structure' && <StructureBoard onOpenReporting={openReporting} />}
              {activeComponent === 'protocool' && <Protocool />}
              {activeComponent === 'academy' && <AcademyWorkspace />}
              {activeComponent === 'finance' && <FinanceDashboard initialView={financeView} />}
              {activeComponent === 'settings' && (
                <div className="td-settings">
                  <div className="td-subnav-wrap">
                    <div className="td-subnav">
                      {SETTINGS_TABS.map((t) => (
                        <button
                          key={t.id}
                          type="button"
                          className={`td-subtab ${settingsView === t.id ? 'td-subtab-active' : ''}`}
                          onClick={() => setSettingsView(t.id)}
                        >
                          {settingsView === t.id && (
                            <motion.span layoutId="td-subtab-pill" className="td-subtab-pill" transition={{ type: 'spring', stiffness: 380, damping: 32 }} />
                          )}
                          <span className="td-subtab-label">{t.icon}{t.label}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="td-settings-body">
                    {settingsView === 'team' && <TeamSettings />}
                    {settingsView === 'calculator' && <CommissionCalculator />}
                    {settingsView === 'setups' && <SetupPackages />}
                    {settingsView === 'templates' && <EmailTemplateSettings />}
                    {settingsView === 'reportingmails' && <ReportingMailSettings />}
                  </div>
                </div>
              )}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </MotionConfig>
  );
};

export default TeamDashboard;
